import React from 'react';

import styles from './FormText.module.scss';

export interface FormTextPropsI {
  children: React.ReactNode;
  underline?: boolean;
  onClick?: () => void;
  margin?: string;
}

const FormText = ({ children, underline, onClick, margin }: FormTextPropsI): JSX.Element => {
  console.log(margin)
  return (
    <span
      className={styles.FormText}
      onClick={onClick}
      style={{
        textDecoration: underline ? 'underline' : '',
        margin: margin ? margin : '',
        cursor: underline ? 'pointer' : ''
      }}
    >
      {children}
    </span>
  );
};

export interface FormTextLinkPropsI {
  children: React.ReactNode;
  link?: string;
  onClick?: () => void;
  variant?: 'blue' | 'gray';
  margin?: string;
}

const FormTextLink: React.FC<FormTextLinkPropsI> = ({ children, link, onClick, variant, margin }) => {
  return (
    <a
      className={styles.FormText__link}
      onClick={(e) => {
        e.stopPropagation();
        if (onClick) {
          onClick();
        }
      }}
      href={link}
      style={{
        color: variant === 'gray' ? '#8e9b9e' : '',
        fontWeight: variant === 'gray' ? 'normal' : '',
        margin: margin ? margin : ''
      }}
    >
      {children}
    </a>
  );
};

FormText.Link = FormTextLink;

export default FormText;
